/**
 * Detects "stores-mobile" surfaces — i.e. contexts where Apple App Store
 * or Google Play Store 30% royalty policy on in-app digital goods applies.
 *
 * Phase 42 · Feb 2026 — DISABLED for Nymia's current distribution model.
 *
 * Rationale:
 *   Nymia is distributed exclusively as a Progressive Web App / web
 *   application at nymia.me. It is NOT published on the Apple App Store
 *   nor on Google Play. Under Apple's and Google's own guidelines the
 *   30% commission on digital goods applies only to apps distributed via
 *   their stores; standalone web browsers and web-installed PWAs are
 *   explicitly out of scope.
 *
 *   Keeping the previous gate on (which matched ANY mobile UA) blocked
 *   legitimate mobile customers from topping up their Wallet, purchasing
 *   Live tickets, One-to-One sessions and content — resulting in a
 *   material revenue leak with no compliance benefit.
 *
 *   The function is retained (returning `false`) so existing callers in
 *   `InsufficientBalanceDialog` and `ShopPage` remain source-compatible.
 *   If in the future Nymia ever ships a native iOS/Android app, this
 *   file is the single switch point: flip the logic back on and both
 *   call-sites will pick it up automatically.
 */
export const isStoresMobile = () => false;

/** Re-export as default for convenience. */
export default { isStoresMobile };
